import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { SubcategoriaService } from '@app/services/subcategoria.service';
import { Subcategoria } from '@app/models/subcategoria.model';

@Component({
  selector: 'app-subcategorias-form',
  templateUrl: './subcategorias-form.component.html'
})
export class SubcategoriasFormComponent implements OnInit {

  aguardandoSolicitacao : boolean = false;
  titulo: string;
  lstErros: string[];
  subcategoria: Subcategoria = new Subcategoria();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private subcategoriaService: SubcategoriaService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar SubCategoria de Documento' : 'Nova SubCategoria de Documento';

      if (!id) {
        return;
      }

      this.subcategoriaService.obterPorId(id).toPromise().then(
        data => {
          data.Descricao = (data.Descricao).trim();
          this.subcategoria = data;

        },
        () => this.router.navigate(['./configuracoes/subcategoria']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.subcategoriaService.gravar(this.subcategoria).toPromise().then(
      () => this.router.navigate(['./configuracoes/subcategoria']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
